import {
	Backdrop,
	Button,
	Divider,
	Fade,
	Grid,
	makeStyles,
	Modal,
	TextField,
	Typography,
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useContext, useEffect, useState } from "react";
import { config as url } from "../../../common/config";
import authContext from "../../../context/Auth/authContext";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import AlertNotistack from "../AlertNotistack";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "center",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "0.125rem solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2),
		borderRadius: 5,
		marginTop: "4.688rem",
	},
	form: {
		flexBasis: "700px",
		[theme.breakpoints.down("sm")]: {
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2),
		},
		position: "relative",
	},
	fields: {
		marginTop: theme.spacing(0),
	},
	textField: {
		width: "100%",
		"& + & ": {
			marginTop: theme.spacing(1.5),
		},
	},
	title: {
		marginBottom: theme.spacing(1),
		color: theme.palette.primary.main,
	},
	alert: {
		marginBottom: theme.spacing(2),
	},
	button: {
		marginTop: theme.spacing(2),
		width: "22.25%",
		marginLeft: theme.spacing(2),
	},
	buttonClose: {
		marginTop: theme.spacing(2),
		width: "22.25%",
		backgroundColor: theme.palette.error.main,
		"&:hover": {
			backgroundColor: theme.palette.error.dark,
		},
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
}));

const EditPassword = ({ open, handleCloseModal }) => {
	const classes = useStyles();
	const BaseUrl = `${url.users}`;
	const { enqueueSnackbar } = useSnackbar();
	const fetchData = useContext(FetchDataContext);
	const { updateData } = fetchData;

	const AuthContext = useContext(authContext);
	const { user, loadUserInfo } = AuthContext;

	const [state, setState] = useState({
		id: "",
		oldpw: "",
		newpw: "",
		newpw2: "",
	});

	const { oldpw, newpw, newpw2 } = state;

	const handleEdit = (e) => {
		e.preventDefault();
		if (newpw !== newpw2) {
			return enqueueSnackbar("Password do not match", AlertNotistack("error"));
		}
		editData(state);
	};

	const handleSubmit = () => {
		return false;
	};
	const editData = async (data) => {
		const result = await updateData(
			`${BaseUrl}/change/password?id=${data.id}`,
			data,
			handleSubmit
		);
		if (result.status === "success") {
			setTimeout(() => {
				closeModal();
				loadUserInfo();
			}, 2000);
		}
		return result;
	};

	const handleFieldChange = (e) => {
		setState({ ...state, [e.target.name]: e.target.value });
	};

	const closeModal = () => {
		handleCloseModal();
		setState({
			...state,
			oldpw: "",
			newpw: "",
			newpw2: "",
		});
	};

	useEffect(() => {
		if (user) {
			setState({
				id: user.id,
			});
		}
	}, [user]);

	return (
		<Grid>
			<Modal
				disablePortal
				disableEnforceFocus
				disableAutoFocus
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={closeModal}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<Grid
						item
						xl={3}
						lg={4}
						md={5}
						sm={6}
						xs={11}
						className={classes.paper}
					>
						<Typography className={classes.title} variant="h4">
							Edit Password
						</Typography>
						<Divider />
						<Typography className={classes.alert}></Typography>
						<form className={classes.form} onSubmit={handleEdit}>
							<Grid className={classes.fields}>
								<TextField
									className={classes.textField}
									label="Old Password"
									name="oldpw"
									onChange={handleFieldChange}
									type="password"
									value={oldpw}
									variant="outlined"
									autoComplete="off"
									inputProps={{
										minLength: 6,
									}}
									required
								/>
								<TextField
									className={classes.textField}
									label="New Password"
									name="newpw"
									onChange={handleFieldChange}
									type="password"
									value={newpw}
									variant="outlined"
									autoComplete="off"
									inputProps={{
										minLength: 6,
									}}
									required
								/>
								<TextField
									className={classes.textField}
									label="Retype New Password"
									name="newpw2"
									onChange={handleFieldChange}
									type="password"
									value={newpw2}
									variant="outlined"
									autoComplete="off"
									required
								/>
							</Grid>
							<Divider style={{ marginTop: "1rem" }} />
							<Grid style={{ display: "flex", flexDirection: "row-reverse" }}>
								<Button
									className={classes.button}
									color="primary"
									type="submit"
									size="large"
									variant="contained"
								>
									Save
								</Button>
								<Button
									className={classes.buttonClose}
									size="large"
									variant="contained"
									onClick={closeModal}
								>
									Close
								</Button>
							</Grid>
						</form>
					</Grid>
				</Fade>
			</Modal>
		</Grid>
	);
};

export default EditPassword;
